import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { Avatar, Button, Icon } from 'antd';
import MenuSwitch from './components/MenuSwitch';
import PlanMenu from './components/PlanMenu';
import NoPlanMenu from './components/NoPlanMenu';
import OrganisationMenu from './components/OrganisationMenu';
import { organisationUserRoleSelector } from '../../scenes/Admin/scenes/User/UserSelectors';
import { planExpiryDateSelector } from '../../scenes/Dashboard/scenes/Plan/PlanSelectors';
import { getPlanExpiryStatus } from '../PlanExpiryBadge/plan-expiry-shared';
import { isPurchaseEnabled } from '../../utils/featureGates';
import './Sider.scss';

const MENU_KEY_ORG = '/organization';

const Sider = ({ match, location, history, userRole, businessInfo, currentPlan, collapsed, toggle, planExpiry }) => {
  const [subMenu, setSubMenu] = useState(match.url);
  const hasBusinessInfo = Boolean(businessInfo && 'name' in businessInfo);
  const businessName = hasBusinessInfo ? businessInfo.name : null;
  const logo = hasBusinessInfo ? businessInfo.avatarUrl : null;
  const selectedKey = location.pathname;
  const hasPlan = Boolean(currentPlan && 'planId' in currentPlan);
  const planExpiryStatus = planExpiry ? getPlanExpiryStatus(planExpiry) : null;
  const isPlanActive = planExpiryStatus === 'not-expired';

  const collapseButton = toggle ? (
    <button
      type="button"
      className={classNames('sider-brand-collapse', {
        'sider-brand-collapse--stacked': collapsed,
      })}
      onClick={toggle}
      aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
    >
      <Icon type={collapsed ? 'right' : 'left'} aria-hidden />
    </button>
  ) : null;

  return (
    hasBusinessInfo && (
      <div className={classNames('sider-app', { 'sider-app--collapsed': collapsed })}>
        <div className="sider-app-body">
          <div className={classNames('sider-nav-controls', { 'sider-nav-controls--collapsed': collapsed })}>
            <MenuSwitch
              collapsed={collapsed}
              selectedKey={subMenu || match.url}
              onChange={({ key }) => setSubMenu(key)}
            />
            {collapseButton}
          </div>

        {subMenu === MENU_KEY_ORG ? (
          <nav className="sider-nav-section" aria-label="Organisation navigation">
            {!collapsed && (
              <div className="sider-context sider-context--org">
                <div className="sider-context-body">
                  <div className="sider-context-name-row">
                    <Avatar
                      size={36}
                      icon="bank"
                      src={logo}
                      className="sider-context-avatar sider-context-avatar--org"
                      alt=""
                    />
                    <div className="sider-context-name" title={businessName || undefined}>
                      {businessName || 'Create Business'}
                    </div>
                  </div>
                  <div className="sider-context-actions">
                    <Button
                      type="default"
                      size="small"
                      className="sider-context-btn"
                      onClick={() => history.push('/organization/list')}
                    >
                      Change Organisation
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <OrganisationMenu selectedKey={selectedKey} userRole={userRole} />
          </nav>
        ) : (
          <nav className="sider-nav-section" aria-label="Plan navigation">
            {!collapsed && (
              <div className="sider-context sider-context--plan">
                <div className="sider-context-body">
                  <div className="sider-context-name-row">
                    <Avatar
                      size={36}
                      icon="file-text"
                      className="sider-context-avatar sider-context-avatar--plan"
                      alt=""
                    />
                    <span
                      className="sider-context-name"
                      title={hasPlan ? currentPlan.name : undefined}
                    >
                      {hasPlan ? currentPlan.name : 'No Plan'}
                    </span>
                    {isPlanActive && (
                      <span className="sider-status-badge">active</span>
                    )}
                  </div>
                  <div className="sider-context-actions">
                    {hasPlan ? (
                      <>
                        <Button
                          type="default"
                          size="small"
                          className="sider-context-btn"
                          onClick={() => history.push('/dashboard/plans')}
                        >
                          Change Plan
                        </Button>
                        <Button
                          type="primary"
                          size="small"
                          className="sider-context-btn sider-context-btn--primary"
                          onClick={() => history.push('/organization/plans')}
                        >
                          New Plan
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          type="primary"
                          size="small"
                          className="sider-context-btn sider-context-btn--primary"
                          onClick={() => history.push('/organization/plans')}
                        >
                          Add First Plan
                        </Button>
                        {isPurchaseEnabled() ? (
                          <Button
                            type="default"
                            size="small"
                            className="sider-context-btn"
                            onClick={() => history.push('/purchase')}
                          >
                            Buy subscriptions
                          </Button>
                        ) : null}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            {hasPlan ? <PlanMenu selectedKey={selectedKey} /> : <NoPlanMenu selectedKey={selectedKey} />}
          </nav>
        )}
        </div>
      </div>
    )
  );
};

const mapStateToProps = state => {
  const { organisationReducer, planReducer } = state;
  return {
    userRole: organisationUserRoleSelector(state),
    businessInfo: organisationReducer.businessInfo || {},
    currentPlan: planReducer.currentPlan,
    planExpiry: planExpiryDateSelector(state),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(Sider)
);
